module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bSLPJ"))).then(() => parcelRequire('ljYL6'));